import React from 'react';

export type RouteConfig = {
    exact?: boolean;
    path?: string | null;
    component?: React.ReactNode | null;
    render?: React.ReactNode | null;
    private?: boolean;
    useLayout?: boolean;
    title?: string | null;
    [key: string]: any;
};

const defaultRoute: RouteConfig = {
    exact: false,
    path: null,
    component: null,
    private: false,
    useLayout: true,
    title: null,
};

export default function createRoute(routeConfig: Partial<RouteConfig> = {}) {
    const fullRoute: RouteConfig = { ...defaultRoute, ...routeConfig } as RouteConfig;
    const { exact, path, render, ...extras } = fullRoute;

    return {
        route: { exact, path },
        extras,
        render,
    } as {
        route: { exact?: boolean; path?: string | null };
        extras: Omit<RouteConfig, 'exact' | 'path' | 'render'> & { [k: string]: any };
        render?: React.ReactNode | null;
    };
}

export type CreatedRoute = ReturnType<typeof createRoute>;
